import { create } from 'zustand';
import {
  assignedFetchData,
  fetchInstantRefund,
  getPreviousAssignee,
  setEscalationPrescritiption,
  shopifyReturn,
  assignedTicketsStatsData,
  downloadAssignedTickets,
  fetchMedicalEscalationTickets,
  fetchDownloadMedicalEscalationTickets,
  orderCancellationShopify,
  makeShopifyPartialReturnRefund,
  fetchDownloadMedicalEscalationPrescription,
} from '../api_layer/api';
import { updateAssignedTickets } from '../api_layer/api';
import { fetchDataDownload } from '../api_layer/api';
import { uploadImageTicket } from '../api_layer/api';
import { getAssignee } from '../api_layer/api';
import moment from 'moment';
import { toast } from 'react-toastify';
import { TOAST_MESSAGE_CSS } from 'modules/utilities/utility';
import secureLocalStorage from 'react-secure-storage';
import _ from 'lodash';

const useAssignedStore = create((set) => ({
  assignedTicketData: [],
  downloadData: [],
  dataFilter: false,
  responseData: [],
  assigneeData: [],
  previousAssignee: [],
  cancelData: [],
  prescriptionData: [],
  assigneeLoading: false,
  refundResponse: [],
  medEscResponse: {},
  medEscResponseLoading: false,
  medEscResponseDownload: {},
  prescriptionSignedUrl: null,
  medEscPrescDownload: {},
  statsLoading: false,
  assignLoading: false,
  assignedTicketLoading: false,
  assignedLoading: false,
  updateLoading: false,
  cancelLoading: false,
  error: null,
  assignedTicketError: null,
  assignedTicketStats: {},
  fetchAssignedData: async (sd, ed, newPage, query) => {
    const startDate = moment(sd).startOf('day').toISOString();
    const endDate = moment(ed).endOf('day').toISOString();
    try {
      set({
        assignedTicketLoading: true,
        assignedLoading: true,
        error: null,
        assignedTicketError: null,
      });
      const response = await assignedFetchData(
        startDate,
        endDate,
        newPage,
        query
      );
      set({
        assignedTicketData: response.data,
        assignedTicketLoading: false,
        assignedLoading: false,
      });
    } catch (error) {
      set({
        error: error.message,
        assignedTicketError: error.message,
        assignedTicketLoading: false,
        assignedLoading: false,
      });
    }
  },
  fetchAssignedTicketStats: async (sd, ed, query) => {
    let startDate = moment(sd).startOf('day').toISOString();
    let endDate = moment(ed).endOf('day').toISOString();
    try {
      const response = await assignedTicketsStatsData(
        startDate,
        endDate,
        query
      );
      set({ assignedTicketStats: response.data });
    } catch (error) {
      console.log('error', error);
    }
  },
  assignedTicketDownloads: async (sd, ed, query) => {
    let startDate = moment(sd).startOf('day').toISOString();
    let endDate = moment(ed).endOf('day').toISOString();
    const payload = {
      startDate: startDate,
      endDate: endDate,
    };
    try {
      set({
        assignedTicketLoading: true,
        assignedTicketError: null,
        error: null,
      });
      await downloadAssignedTickets(query, payload);
      toast.success(`Email sent at ${secureLocalStorage.getItem('email')}`, {
        position: 'top-center',
      });
    } catch (error) {
      toast.error(
        `Failed to send email at ${secureLocalStorage.getItem('email')}`,
        {
          position: 'top-center',
        }
      );
      console.log('Error ', error);
    }
  },
  fetchDownloads: async (sd, ed) => {
    try {
      set({ assignLoading: true, error: null, assignedTicketError: null });
      const response = await fetchDataDownload(sd, ed);
      set({ downloadData: response.data, assignLoading: false });
    } catch (error) {
      set({
        error: error.message,
        assignedTicketError: error.message,
        assignLoading: false,
      });
    }
  },
  updateAssignedData: async (id, payload) => {
    try {
      set({ updateLoading: true, error: null, assignedTicketError: null });
      const response = await updateAssignedTickets(id, payload);
      toast.success('Ticket Updated Successfully');
      set({ responseData: response.data, updateLoading: false });
    } catch (error) {
      toast.error(`Ticket Updation Failed | ${error.message}`);
      console.error('error in update ticketId', error, payload);
      set({
        error: error.message,
        assignedTicketError: error.message,
        updateLoading: false,
      });
    }
  },
  fetchAssigneeData: async (payload) => {
    try {
      set({ assigneeLoading: true, error: null, assignedTicketError: null });
      const response = await getAssignee(payload);
      set({ assigneeData: response.data, assigneeLoading: false });
    } catch (error) {
      set({
        error: error.message,
        assignedTicketError: error.message,
        assigneeLoading: false,
      });
    }
  },
  updateImageData: async (data, id) => {
    try {
      await uploadImageTicket(data, id);
    } catch (error) {
      set({
        error: error.message,
        assignedTicketError: error.message,
        assignLoading: false,
      });
    }
  },
  postCancelOrder: async (payload) => {
    try {
      set({ cancelLoading: true, error: null, assignedTicketError: null });
      const response = await shopifyReturn(payload);
      toast.success('order cancelled Successfully');
      set({ cancelData: response.data, cancelLoading: false });
    } catch (error) {
      toast.error('cancel order failed');
      set({
        error: error.message,
        assignedTicketError: error.message,
        cancelLoading: false,
      });
    }
  },
  fetchPreviousAssignee: async (ticketId) => {
    try {
      const response = await getPreviousAssignee(ticketId);
      set({ previousAssignee: response.data, assigneeLoading: false });
    } catch (error) {
      set({
        error: error.message,
        assignedTicketError: error.message,
        assignLoading: false,
      });
    }
  },
  postEscalationPrescritiption: async (tikcetIid, prescription) => {
    try {
      const doctorId = _.get(prescription, 'doctor', false);
      if(!doctorId){
        toast.error('Doctor Id is missing');
      } else{
        const result = await setEscalationPrescritiption(tikcetIid, prescription);
        const prescriptionSignedUrl = result?.data?.data?.prescriptionSignedUrl;
        if (prescriptionSignedUrl) window.open(prescriptionSignedUrl, '_blank');
        set({ prescriptionData: result?.data?.data?.response, assigneeLoading: false, prescriptionSignedUrl });
      }
    } catch (error) {
      set({
        error: error.message,
        assignedTicketError: error.message,
        assignLoading: false,
      });
    }
  },
  getInstantRefund: async (
    orderDisplayId,
    totalPrice,
    ticketId,
    actionTaker
  ) => {
    try {
      const payload = { orderDisplayId, totalPrice, ticketId, actionTaker };
      const result = await fetchInstantRefund(payload);
      set({ refundResponse: result, assignLoading: false });
    } catch (error) {
      set({
        refundResponse: error?.response?.data?.message,
        assignLoading: false,
      });
    }
  },
  getMedicalEscalationTickets: async (
    page,
    status,
    subCatKey,
    selectedUser,
    startDate,
    endDate
  ) => {
    try {
      set({ medEscResponseLoading: true });
      const result = await fetchMedicalEscalationTickets(
        page,
        status,
        subCatKey,
        selectedUser,
        startDate,
        endDate
      );
      set({ medEscResponse: result.data, medEscResponseLoading: false });
    } catch (error) {
      set({
        medEscResponse: error?.response?.data?.message,
        medEscResponseLoading: false,
      });
    }
  },
  postShopifyPartialReturnRefund: async (payload) => {
    try {
      await makeShopifyPartialReturnRefund(payload);
      toast.success('Refund Initiated');
    } catch (error) {
      toast.error('failed to initiate refund');
    }
  },
  getDownloadMedicalEscalationPrescription: async (
    startDate,
    endDate
  ) => {
    try {
      const result = await fetchDownloadMedicalEscalationPrescription(
        startDate,
        endDate
      );
      set({ medEscPrescDownload: result.data, assignLoading: false });
    } catch (error) {
      set({
        medEscPrescDownload: error?.response?.data?.message,
        assignLoading: false,
      });
    }
  },
  getDownloadMedicalEscalationTickets: async (
    status,
    subCatKey,
    selectedUser,
    startDate,
    endDate
  ) => {
    try {
      const result = await fetchDownloadMedicalEscalationTickets(
        status,
        subCatKey,
        selectedUser,
        startDate,
        endDate
      );
      set({ medEscResponseDownload: result.data, assignLoading: false });
    } catch (error) {
      set({
        medEscResponse: error?.response?.data?.message,
        assignLoading: false,
      });
    }
  },
  postOrderCancellationShopify: async (payload, toast) => {
    try {
      await orderCancellationShopify(payload);
      toast.success('Order is cancelled successfully', TOAST_MESSAGE_CSS);
    } catch (error) {
      toast.error('Order Cancellation Failed', TOAST_MESSAGE_CSS);
    }
  },
}));

export default useAssignedStore;
